/** Shell 상단 헤더 — 카카오 공식 채널 (앱 `AppConfig.kakaoOfficialChannelUrl` 과 동일 기본값) */
export const KAKAO_OFFICIAL_CHANNEL_URL = String(
  process.env.REACT_APP_KAKAO_OFFICIAL_CHANNEL_URL || 'https://pf.kakao.com/_jVPAX',
).trim()

export const SUPPORT_INQUIRIES_PATH = '/support/inquiries'
